
import React from "react";

interface TypingIndicatorProps {
  side?: "left" | "right";
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ side = "left" }) => {
  return (
    <div className={`flex ${side === "right" ? "justify-end" : "justify-start"} mb-4`}>
      <div className={`max-w-[80%] p-4 text-base leading-6 break-words ${
        side === "right" 
          ? "bg-muted text-foreground rounded-[16px_16px_0px_16px]" 
          : "bg-card text-card-foreground rounded-2xl border"
      }`}>
        <div className="flex items-center space-x-1">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-muted-foreground/60 rounded-full animate-typing-dot-1" />
            <div className="w-2 h-2 bg-muted-foreground/60 rounded-full animate-typing-dot-2" />
            <div className="w-2 h-2 bg-muted-foreground/60 rounded-full animate-typing-dot-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
